import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatorCoreModule } from '../../../../../creator-core/creator-core.module';
import { FileUploadModule } from '../file-upload/file-upload.module';

import {
	ColorPickerComponent,
	DatePickerComponent,
	FontBoxComponent,
	NumberBoxComponent,
	ImageBoxComponent,
	LabelComponent,
	TextBoxComponent,
	UrlBoxComponent,
	SelectBoxComponent,
	MultiSelectComponent,
	TextAreaComponent,
	RadioButtonComponent,
	CheckBoxComponent,
	SearchBoxComponent,
	FileBoxComponent
} from './index';

import { DynamicFormComponent } from './df/dynamic-form.component';
import { DynamicFormFieldComponent } from './df-field/dynamic-form-field.component';

import { DynamicFormPackageControlService } from './services/df-package-control.service';
import { ComponentService } from '../../../../../services/component.service';
import { FontFamilyService } from './services/df-font-family.service';
@NgModule({
	imports: [CommonModule, CreatorCoreModule, FileUploadModule],
	declarations: [
		ColorPickerComponent,
		DatePickerComponent,
		FontBoxComponent,
		NumberBoxComponent,
		ImageBoxComponent,
		LabelComponent,
		TextBoxComponent,
		UrlBoxComponent,
		DynamicFormComponent,
		SelectBoxComponent,
		DynamicFormFieldComponent,
		MultiSelectComponent,
		TextAreaComponent,
		RadioButtonComponent,
		CheckBoxComponent,
		SearchBoxComponent,
		FileBoxComponent
	],
	exports: [
		ColorPickerComponent,
		DatePickerComponent,
		FontBoxComponent,
		ImageBoxComponent,
		LabelComponent,
		TextBoxComponent,
		NumberBoxComponent,
		UrlBoxComponent,
		SelectBoxComponent,
		DynamicFormComponent,
		DynamicFormFieldComponent,
		MultiSelectComponent,
		TextAreaComponent,
		RadioButtonComponent,
		CheckBoxComponent,
		SearchBoxComponent,
		FileBoxComponent
	],
	providers: [ComponentService, DynamicFormPackageControlService, FontFamilyService]
})
export class DynamicFormModule {}
